import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import IntegrationsPage from "../pages/integrations/page";
import ModulesPage from "../pages/modules/page";
import FAQPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";
import PrivacyPolicy from "../pages/legal/privacy-policy";
import CookiesPolicy from "../pages/legal/cookies-policy";
import TermsConditions from "../pages/legal/terms-conditions";
import LegalNotice from "../pages/legal/legal-notice";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/modulos",
    element: <ModulesPage />,
  },
  {
    path: "/integraciones",
    element: <IntegrationsPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/nosotros",
    element: <AboutPage />,
  },
  {
    path: "/politica-privacidad",
    element: <PrivacyPolicy />,
  },
  {
    path: "/politica-cookies",
    element: <CookiesPolicy />,
  },
  {
    path: "/terminos-condiciones",
    element: <TermsConditions />,
  },
  {
    path: "/aviso-legal",
    element: <LegalNotice />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
